// extracted by mini-css-extract-plugin
module.exports = {"patientCol":"Table_patientCol__1i6sJ"};